import gql from 'graphql-tag'

export const EXPORT_PDF_REPORT_MANAGEMENT_VEHICLE = gql`
  query PdfReportManagementVehicle($filter: PdfReportManagementVehicleFilter!) {
    pdfReportManagementVehicle(filter: $filter) {
      isSuccessful
      message
      pdfReportManagementVehicle {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_MANAGEMENT_DRIVER = gql`
  query PdfReportManagementDriver($filter: PdfReportManagementDriverFilter) {
    pdfReportManagementDriver(filter: $filter) {
      isSuccessful
      message
      pdfReportManagementDriver {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_SUMMARY_DAY_VEHICLE = gql`
  query PdfReportSummaryDayVehicle($filter: PdfReportSummaryDayVehicleFilter!) {
    pdfReportSummaryDayVehicle(filter: $filter) {
      isSuccessful
      message
      PdfReportSummaryDayVehicle {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_SUMMARY_DAY_DRIVER = gql`
  query PdfReportSummaryDayDriver($filter: PdfReportSummaryDayFilter) {
    pdfReportSummaryDayDriver(filter: $filter) {
      isSuccessful
      message
      PdfReportSummaryDayDriver {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_HISTORY_VEHICLE = gql`
  query PdfReportVehicleTrip($filter: PdfReportVehicleTripFilter) {
    pdfReportVehicleTrip(filter: $filter) {
      isSuccessful
      message
      pdfReportVehicleTrips {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_DETAIL_HISTORY_VEHICLE = gql`
  query PdfReportDetailVehicleTrip($filter: PdfReportDetailVehicleTripFilter!) {
    pdfReportDetailVehicleTrip(filter: $filter) {
      isSuccessful
      message
      pdfReportDetailVehicleTrips {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_SUMMARY_STOPPED = gql`
  query PdfReportSummaryStopped($filter: PdfReportSummaryStoppedFilter!) {
    pdfReportSummaryStopped(filter: $filter) {
      isSuccessful
      message
      pdfReportSummaryStopped {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_GEOLOCATION = gql`
  query PdfReportGeolocation($filter: PdfReportGeolocationFilter!) {
    pdfReportGeolocation(filter: $filter) {
      isSuccessful
      message
      pdfReportGeolocation {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_SUMMARY_GEOLOCATION = gql`
  query PdfReportSummaryGeolocation($filter: GetReportPdfSummaryGeolocationFilter!) {
    pdfReportSummaryGeolocation(filter: $filter) {
      isSuccessful
      message
      pdfReportSummaryGeolocation {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_ALERT = gql`
  query PdfReportAlert($filter: PdfReportAlertFilter!) {
    pdfReportAlert(filter: $filter) {
      isSuccessful
      message
      pdfReportAlert {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_DOOR = gql`
  query PdfReportDoor($filter: ExcelPdfDoorFilter!) {
    pdfReportDoor(filter: $filter) {
      isSuccessful
      message
      pdfReportDoor {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_RAW_SENSOR = gql`
  query PdfRawSensorInfos($filter: GetPdfRawSensorInfoFilter) {
    pdfRawSensorInfos(filter: $filter) {
      isSuccessful
      message
      pdfRawSensorInfos {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_CHART_RAW_SENSOR = gql`
  query PdfChartRawSensorInfos($filter: GetPDFChartRawSensorInfoFilter!) {
    pdfChartRawSensorInfos(filter: $filter) {
      isSuccessful
      message
      status
      pdfChartRawSensorInfos {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_FUEL = gql`
  query PdfReportFuel($filter: GetPdfReportFuelFilter!) {
    pdfReportFuel(filter: $filter) {
      isSuccessful
      message
      pdfReportFuel {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_CHART_FUEL = gql`
  query PdfChartReportFuel($filter: GetPdfChartReportFuelFilter!) {
    pdfChartReportFuel(filter: $filter) {
      isSuccessful
      message
      pdfChartReportFuel {
        base64
        id
      }
    }
  }
`
export const EXPORT_PDF_REPORT_TIME_WINDOW = gql`
  query PdfReportTimeWindow($filter: PdfReportTimeWindowFilter!) {
    pdfReportTimeWindow(filter: $filter) {
      isSuccessful
      message
      pdfReportTimeWindow {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_DRIVER_SCORES = gql`
  query PdfReportDriverScores($filter: PdfReportDriverScoresFilter) {
    pdfReportDriverScores(filter: $filter) {
      isSuccessful
      message
      pdfReportDriverScores {
        base64
        id
      }
    }
  }
`

export const EXPORT_PDF_REPORT_OFFLINE_VEHICLE = gql`
  query PdfReportVehiclesOffline($filter: PdfReportVehicleOfflineFilter) {
    pdfReportVehiclesOffline(filter: $filter) {
      isSuccessful
      message
      status
      pdfReportVehicleOffline {
        base64
        id
      }
    }
  }
`
